module.exports = __webpack_public_path__ + "static/media/logo-full.59259d7f.png";